import Comp from './companyHistory';

export default Comp;
